import React from 'react';
import { analytics } from '@/utils/analytics';

interface ExternalLinkTrackerProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  trackingLabel?: string;
}

export const ExternalLinkTracker: React.FC<ExternalLinkTrackerProps> = ({
  href,
  children,
  className,
  trackingLabel
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Track external link click
    analytics.trackExternalLink(href);
    
    // Track with custom label if provided
    if (trackingLabel) {
      analytics.trackEvent({
        action: 'click',
        category: 'navigation',
        label: trackingLabel,
        custom_parameters: {
          link_url: href,
          link_type: 'external'
        }
      });
    }
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      onClick={handleClick}
    >
      {children}
    </a>
  );
};

export default ExternalLinkTracker;